import React from 'react'

import { classNames } from '../../utils/dom'

import { ReactComponent as MapSearchIcon } from '../../assets/icons/ui/map-search.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/ui/close.svg'

const GoogleMapControls = ({ location, onLocationSubmit, onLocationChange, children }) => {
  
  const inventoryReportMap = window.location.href.split('/').pop() === 'InventoryReport'
  const handleLocationSubmit = (event) => {
    event.preventDefault()
    onLocationSubmit({ location })
  }

  const handleLocationChange = (event) => {
    const { value: location } = event.target
    onLocationChange({ location })
  }

  const handleClearLocation = () => handleLocationChange({ target: { value: '' } })

  return (
    <div className="map-nav-bar">
      <form onSubmit={handleLocationSubmit} className="map-address-form">

        <div className="map-nav-bar-input input-icon-wrap">
    
          <span className="input-icon map-nav-bar-search-submit">
            <MapSearchIcon onClick={handleLocationSubmit} />
          </span>

          <input
            type="text"
            className="input-with-icon"
            placeholder={inventoryReportMap ? "Enter your streetname, city and zipcode" :"Enter address nearest to light"}
            value={location}
            onChange={handleLocationChange}
          />
          <span className="input-icon">
            <CloseIcon
              onClick={handleClearLocation}
              className={classNames(['icon', 'icon-close', (location && 'visible') || 'hidden'])}
            />
          </span>
        </div>

      </form>
      { children }
    </div>
  )
}

export default GoogleMapControls
